import { Component } from '@angular/core';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { MatDialogConfig } from '@angular/material/dialog';

@Component({
	selector: 'app-user-feedback-modal-dialog',
	template: ''	
})
export class UserFeedbackModalDialogComponent {
	constructor(public dialog: Dialog) 
	{ 
		
	}

	public openDialog(dialogData: any): void 
	{
		const dialogConfig = new MatDialogConfig();

		dialogConfig.disableClose = true; // disable close on escape, instead handle the key event in ModalDialogComponent and close
		dialogConfig.autoFocus = "first-tabbable";	
		dialogConfig.restoreFocus = true;	
		dialogConfig.ariaModal = true;
		dialogConfig.role = "dialog";
		dialogConfig.data = dialogData.data;				

		this.dialog.open(ModalDialogComponent, dialogConfig);
	}

	public closeDialog() : void
	{
		this.dialog.closeAll();
	}
}
